import React from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import Button from 'components/Button';
import history from 'routing/history';
import { StyledProductCard, Title, Description } from './styled';

const ProductCard = ({
  title,
  description,
  callToAction,
  primaryColor,
  secondaryColor,
  noGlow,
  children
}) => {
  const { ref, inView } = useInView({
    threshold: 0.5
  });

  return (
    <StyledProductCard
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      ref={ref}
      inView={inView}
      noGlow={noGlow}
    >
      <div>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </div>
      {callToAction && (
        <Button
          onClick={() => {
            if (callToAction?.external) {
              window.location.replace(callToAction.link);
            } else {
              history.push(callToAction.link);
            }
          }}
        >
          {callToAction.text}
        </Button>
      )}
      {children}
    </StyledProductCard>
  );
};

ProductCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  callToAction: PropTypes.shape({
    text: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    external: PropTypes.bool
  }),
  primaryColor: PropTypes.func.isRequired,
  secondaryColor: PropTypes.func,
  noGlow: PropTypes.bool,
  children: PropTypes.node
};

export default ProductCard;
